module.exports = __webpack_public_path__ + "img/friends-img-ua.2af10d98.png";